import React, { useState } from 'react';
import { InlineNotification } from '@ui';
import './AlertStyles.scss';
/**
 * Alert
 *
 * Thin, ERB-mountable wrapper around the design-system `InlineNotification`
 * (`react_component 'Alert'`). It exists because `react_component` only resolves
 * names under `frontend/features/`, and because an ERB caller can pass a string
 * `message` prop but not JSX children. Non-dismissible by default; when
 * `dismissible` is set it manages its own visibility and unmounts on dismiss.
 * The caller decides *whether* to render it (e.g. a server-side date gate).
 *
 * @version 1.0.0
 * @since 2026-08-04
 */
export function Alert({ message, variant = 'info', title, dismissible = false, dismissKey }) {
    const [visible, setVisible] = useState(() => dismissKey ? localStorage.getItem(dismissKey) !== 'true' : true);
    if (!visible)
        return null;
    const handleDismiss = () => {
        if (dismissKey)
            localStorage.setItem(dismissKey, 'true');
        setVisible(false);
    };
    return (React.createElement("div", { className: "alert-inline-notification" },
        React.createElement(InlineNotification, { variant: variant, title: title, dismissible: dismissible, onDismiss: handleDismiss }, message)));
}
Alert.displayName = 'Alert';
export default Alert;
